import { render } from "./NewProfileConsultant.vue?vue&type=template&id=71fb6f16&scoped=true"
import script from "./NewProfileConsultant.vue?vue&type=script&lang=js"
export * from "./NewProfileConsultant.vue?vue&type=script&lang=js"

import "./NewProfileConsultant.vue?vue&type=style&index=0&id=71fb6f16&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71fb6f16"]])

export default __exports__